import React from 'react'
import cardService from '../Service/cardService'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'


export default class index extends React.Component {

    render() {
        const { Model, showModal, showModalAdd, showModalDel, showModalDel2, changeHandler, cancelHandler, errors, List, saveHandler, cancelHandlerDel, cancelHandlerDel2, saveHandlerDel,d } = this.props


        return (

            <div class="mb-10">
                
                <Modal show={showModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Tambah Kartu Kredit/Debit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    {/* + */}
                        <div class="mb-3">
                            <label class="form-label">Nomor Kartu Kredit/Debit*</label>
                            <input inputmode="text" type="text" maxLength="16" placeholder="contoh : 1234 5678 9012 3456" class="form-control noArrow" id="card" value={Model.card_number} onChange={changeHandler("card_number")} />
                            <div class="row pl-3">
                                <img class="img-bank mr-1" src="assets/img/masterCard.png" alt="" />
                                <img class="img-bank mr-1" src="assets/img/iconfinder_jcb_card_payment_358102.png" alt="" />
                                <img class="img-bank mr-1" src="assets/img/iconfinder_363_Visa_Credit_Card_logo_4375165.png" alt="" />
                            </div>
                            <span className="error">{errors["card"]}</span>
                        </div>

                        <div class="row">
                            <div class="col">
                                <label class="form-label">Masa Berlaku*</label>
                                <input type="month" maxLength="5" placeholder="mm/yy " class="form-control" id="validity_period" value={Model.validity_period} onChange={changeHandler("validity_period")} />
                                <span className="error">{errors["validity_period"]}</span>

                            </div>

                            <div class="col">
                                <label class="form-label">CVV*</label>
                                <input type="text" maxLength="3" placeholder="contoh : 123" class="form-control noArrow" id="cvv" value={Model.cvv} onChange={changeHandler("cvv")} />
                                <span className="error">{errors["cvv"]}</span>
                            </div>
                        </div>
                        <p style={{ fontStyle: "italic" }}>*Wajib Diisi</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" onClick={cancelHandler}>Batal</button>
                            <button type="button" class="btn btn-outline-primary ml-2" onClick={saveHandler}>Simpan</button>
                        </div>
                    </Modal.Footer>
                </Modal>


                <Modal show={showModalDel} onHide={cancelHandlerDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus Kartu Kredit/Debit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            Anda setuju untuk menghapus kartu kredit/debit?
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-danger" onClick={cancelHandlerDel}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandlerDel}>Yakin</button>
                    </Modal.Footer>
                </Modal>



                <Modal show={showModalDel2} onHide={cancelHandlerDel2}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus Kartu Kredit/Debit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            Kartu kartu kredit/debit berhasil dihapus
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalAdd} onHide={cancelHandlerDel2}>
                    <Modal.Header closeButton>
                        <Modal.Title>Tambah Kartu Kredit/Debit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            Kartu kredit/debit berhasil ditambah
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}